export default import.meta.ROLLDOWN_FILE_URL_1kFwv9omqY3_JFhTJAYRvg